import React from "react";
import SearchField from "./Search";
import InputSelect from "./InputSelect";
import { MonthsOfTheYear } from "utilities/data";
import { TKIconFilter } from "assets/images/svgs";
import { useSelector } from "react-redux";

const DonationSearchBar = ({ param, searchText, setDonationCurrent }) => {
  const { donations } = useSelector((state) => state.donation);

  return (
    <div className="flex flex-wrap gap-4 justify-between items-center pb-6">
      <div className="flex max-[650px]:flex-wrap gap-4">
        <SearchField className="w-full flex" placeholder={searchText} />
        <div className="w-[170px] max-[650px]:w-full">
          <InputSelect
            options={MonthsOfTheYear}
            optionsHolder="Select Month"
            onChange={(e) => {
              if (e.target.value === "Select Month") {
                setDonationCurrent(donations);
              } else {
                setDonationCurrent(
                  donations.filter(
                    (donation) =>
                      donation.createdAt.split("-")[1] === e.target.value
                  )
                );
              }
            }}
          />
        </div>
      </div>
      <div className="flex gap-1">
        <TKIconFilter />
        <p className="text-[#7A7A7A]">Filter {param}</p>
      </div>
    </div>
  );
};

export default DonationSearchBar;
